import script from "./LastUpdated.vue?vue&type=script&setup=true&lang=js"
export * from "./LastUpdated.vue?vue&type=script&setup=true&lang=js"

import "./LastUpdated.vue?vue&type=style&index=0&id=59076eb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59076eb2"]])

export default __exports__